module.exports = __webpack_public_path__ + "img/28_51.70978507.png";